<template>
  <UIModal
    class="ModalConfirm"
    :class="{
      'ModalConfirm--library-delete': variant === 'library-delete',
    }"
    :isOpen="isOpen"
    @close="emit('close')"
  >
    <template #title>
      <slot name="title">Delete this</slot>
    </template>

    <template #content>
      <div class="ModalConfirm__body">
        <div v-if="$slots.warning" class="ModalConfirm__warning">
          <slot name="warning" />
        </div>
        <slot name="content"> Are you sure you want to delete this?! </slot>
      </div>
    </template>

    <template #actions>
      <slot name="actions">
        <UIButton theme="neutral" @click.prevent="emit('close')">
          Cancel
        </UIButton>
        <UIButton
          :theme="buttonTheme"
          :isLoading="isLoading"
          @click.prevent="emit('confirm')"
        >
          {{ confirmButtonLabel }}
        </UIButton>
      </slot>
    </template>
  </UIModal>
</template>

<script lang="ts" setup>
import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIModal from '@/views/components/ui/modals/UIModal.vue'

const emit = defineEmits(['close', 'confirm'])
withDefaults(
  defineProps<{
    isOpen?: boolean
    isLoading?: boolean
    variant?: 'default' | 'library-delete'
    buttonTheme?:
      'primary' | 'neutral' | 'white' | 'success' | 'error' | 'warning'
    confirmButtonLabel?: string
  }>(),
  {
    isOpen: true,
    variant: 'default',
    buttonTheme: 'error',
    confirmButtonLabel: 'Confirm',
  },
)
</script>

<style lang="scss" scoped>
.ModalConfirm__body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.ModalConfirm__warning {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.75rem;
  border-radius: 0.5rem;
  background: $color-warning-5;
  border: 1px solid $color-warning-30;
}
</style>

<style lang="scss">
.ModalConfirm.ModalConfirm--library-delete.UIModal {
  --modal-size: 38.75rem;
  border-radius: 0.75rem;
}
</style>
